import { axiosApiInstance } from "../../../pages/api/axios";

function renameKeys(obj, keysMap) {
  const keyValues = Object.keys(obj).map((key) => {
    const newKey = keysMap[key] ?? key;
    return { [newKey]: obj[key] };
  });

  return Object.assign({}, ...keyValues);
}

const FRONTEND_TO_BACKEND_KEY_MAPPING = {
  countries: "country",
  exclude_available_providers: "exclude_form_id",
  filter_available_providers: "filter_form_id",
};

function mapParamsToBackend(paramsObject) {
  if (!paramsObject) {
    return {};
  }
  const newParams = renameKeys(paramsObject, FRONTEND_TO_BACKEND_KEY_MAPPING);
  return newParams;
}

export function getAvailableProviders({ params, signal }) {
  return axiosApiInstance
    .get("/d/providers/available/", {
      params: mapParamsToBackend(params),
      signal,
    })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map(
        ({ name, form_id, summary, payin_methods, payout_methods }, index) => ({
          id: index,
          active: false,
          payName: name,
          formID: form_id,
          countries: summary?.countries || [],
          payin: summary?.payin,
          payout: summary?.payout,
          type: summary?.type,
          icon: summary?.icon,
          payinMethods: payin_methods,
          payoutMethods: payout_methods,
        })
      ),
    }));
}

export function getConnectedProviders({ params }) {
  return axiosApiInstance
    .get("/d/providers/connected/", {
      params: mapParamsToBackend(params),
    })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map(
        (
          {
            name,
            id,
            active,
            summary,
            accounts,
            payin_methods,
            payout_methods,
          },
          index
        ) => ({
          id: index,
          active,
          payName: name,
          formID: id,
          countries: summary?.countries || [],
          payin: summary?.payin,
          payout: summary?.payout,
          type: summary?.type,
          icon: summary?.icon,
          accounts,
          payinMethods: payin_methods,
          payoutMethods: payout_methods,
        })
      ),
    }));
}

const unifiedProviderResponseData = (data) => {
  return {
    id: data.global_config.information.id,
    globalConfig: data.global_config,
    summary: {
      capabilities: data.summary.capabilities,
      countries: data.summary.countries,
      description: data.summary.description,
      icon: data.summary.icon,
      logo: data.summary.logo,
      name: data.summary.name,
      payin: data.summary.payin_services,
      payout: data.summary.payout_services,
      type: data.summary.type,
      register_url: data.summary.register_url,
      provider_hash: data.summary.provider_hash,
    },
    services: data.services,
  };
};

export async function getProviderDetails({ formID, type, signal, ...params }) {
  const url = type === "available" ? "providers/form" : "providers";
  return axiosApiInstance
    .get(`/d/${url}/${formID}/`, {
      params: mapParamsToBackend(params),
      signal,
    })
    .then((res) => ({
      ...res.data,
      data: unifiedProviderResponseData(res.data.data),
    }));
}

export function deleteProvider(id) {
  return axiosApiInstance.post(`/d/providers/${id}/delete/`);
}

export async function connectProvider({ type, data, id, mode }) {
  const request =
    type === "connected" ? axiosApiInstance.patch : axiosApiInstance.post;
  const url = type === "connected" ? `providers/${id}` : "providers";
  return request(`/d/${url}/`, data, {
    params: { mode },
  }).then((res) => ({
    id: res.data.data.global_config.information.id,
    type,
    fullResponse: unifiedProviderResponseData(res.data.data),
  }));
}

export function updateConnectionName({ connectionId, name }) {
  return axiosApiInstance.patch(`/d/providers/${connectionId}/update_name/`, {
    name,
  });
}

export async function optInService({ serviceType, isConnectedProvider, data }) {
  const url =
    serviceType === "binlookup"
      ? "/d/providers/bin_lookup/"
      : "/d/providers/ntp/";

  const request = isConnectedProvider
    ? axiosApiInstance.patch
    : axiosApiInstance.post;

  return request(url, data).then((res) => ({
    id: res.data.data.global_config.information.id,
  }));
}

export const copySelfServeApplePayConfiguration = ({
  accounts,
  sourceId,
  underlyingPayinMethod,
  integrationType,
}) => {
  return axiosApiInstance
    .post(`/providers/self_serve_apple_pay/clone/`, {
      source_id: sourceId,
      underlying_pay_in_method: underlyingPayinMethod,
      accounts,
      integration_type: integrationType,
    })
    .then((res) => ({ id: res.data.data.connection_id }));
};
